var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudtech(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6667 22.6667H16C15.1346 22.6665 14.2863 22.4256 13.5499 21.971C12.8134 21.5164 12.218 20.866 11.8299 20.0925C11.4419 19.3189 11.2766 18.4527 11.3525 17.5906C11.4285 16.7285 11.7426 15.9045 12.2599 15.2107C12.7772 14.5169 13.4772 13.9806 14.2817 13.6617C15.0863 13.3428 15.9636 13.254 16.8158 13.405C17.6679 13.5561 18.4613 13.9411 19.1072 14.5171C19.7531 15.0931 20.2261 15.8374 20.4733 16.6667H21.6667C22.4623 16.6667 23.2254 16.9828 23.788 17.5454C24.3506 18.108 24.6667 18.8711 24.6667 19.6667C24.6667 20.4624 24.3506 21.2254 23.788 21.788C23.2254 22.3506 22.4623 22.6667 21.6667 22.6667Z",
    stroke: "#057DCD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudtech);
export default __webpack_public_path__ + "static/media/Cloudtech.14c7d889418569f7c5cd9f10a84253cd.svg";
export { ForwardRef as ReactComponent };